import { render, staticRenderFns } from "./formAprobarPallet.vue?vue&type=template&id=fdf01104&"
import script from "./formAprobarPallet.vue?vue&type=script&lang=js&"
export * from "./formAprobarPallet.vue?vue&type=script&lang=js&"
import style0 from "./formAprobarPallet.vue?vue&type=style&index=0&id=fdf01104&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports